import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/views/Home'
import HomeAll from '@/views/HomeAll'
import MmWl from '@/views/MmWl'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home
    // },
    {
      path: '/HomeAll',
      name: 'HomeAll',
      component: HomeAll
    },
    {
      path: '/',
      name: 'MmWl',
      component: MmWl
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js